  <div class="content-container app-page mat-app-background" style="margin-left: 10px;">
    <mat-toolbar>
      <button mat-icon-button (click)="back()" >

        <mat-icon>
          arrow_back_ios_new
        </mat-icon>
      </button>
      &nbsp;
      {{ 'GAMES.TEAMDETAILS' | translate }}
    </mat-toolbar>

    @if (!Team()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (Team()) {
    <app-team-header [Team]="Team()!"></app-team-header>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="team-details-tabs">
      <mat-tab label="{{'GENERAL.PLAYERS' | translate | uppercase }}" style="min-width: 40px; padding: 12px;">
        <div class="tab-scroll-content">
          <app-team-roster [Roster]="Team()!.Players" [TeamIcon]="Team()!.team.SmallIconFileName" ></app-team-roster>
          <div class="team-name">{{ Team()!.team.Name }}</div>
        </div>
      </mat-tab>
      <mat-tab label="{{'GENERAL.GAMES' | translate | uppercase }}" style="min-width: none; padding: 12px;">
        <div class="tab-scroll-content">
          <mat-nav-list>
            @for(game of Team()!.Games; track game.GameId) {
              <a mat-list-item class="game-nav-item" (click)="openGameDetails(game.GameId)">
                <div class="game-date">{{game.GameDate | date:'yyyy-MM-dd'}}</div>
                <div class="game-title">{{game.HomeTeamName}} - {{game.AwayTeamName}}</div>
              </a>
              <mat-divider></mat-divider>
            }
          </mat-nav-list>
        </div>
      </mat-tab>
</mat-tab-group>
    }


</div>
